// src/hooks/useSurahList.js
import { useEffect, useState } from 'react';
import { surahList } from '../data/surahMeta';
import { fetchAllSurahs } from '../api/quranService';

// English meanings and Meccan/Medinan come from the API; the static list shows instantly meanwhile
let detailsPromise = null;
const loadDetails = () => {
  if (!detailsPromise) {
    detailsPromise = fetchAllSurahs()
      .then((data) => Object.fromEntries((data.surahs || []).map((s) => [Number(s._id), s])))
      .catch(() => ({}));
  }
  return detailsPromise;
};

const merge = (details) => surahList.map((s) => ({
  ...s,
  ename: details[s.id]?.ename || '',
  type: details[s.id]?.type || '',
}));

/**
 * All 114 surahs: {id, name, arabicName, ayahCount, ename, type}.
 */
const useSurahList = () => {
  const [surahs, setSurahs] = useState(() => merge({}));

  useEffect(() => {
    let cancelled = false;
    loadDetails().then((details) => !cancelled && setSurahs(merge(details)));
    return () => { cancelled = true; };
  }, []);

  return surahs;
};

export default useSurahList;
